import compose from '../../../../lib/compose';
import connect from '../../../../store/connect';
import withFeatureFlag from '../../../../components/feature-flag/with-feature-flag';
import withRow from '../../../../components/grid/row/with-row';
import CreditsOfferInfoLabel from '../../../../components/credits-offer-info-label';

const mapStateToProps = ({ components }, ownProps) => {
  const props = components[ownProps.featureName];
  return { withMercadoCredits: props.with_mercado_credits, contentRows: props.content_rows, ...ownProps };
};

const enhance = compose(
  withFeatureFlag(),
  withRow(),
  connect(
    mapStateToProps,
    null,
    'credits_offer_info_label',
  ),
);

export default enhance(CreditsOfferInfoLabel);
